import * as Safe from "safe-portals";
import { CampaignProviderConfigSerializer } from "../../common/campaign_provider";

export const sentMessageSerializer = Safe.obj({
  targets: Safe.array(Safe.str),
  created_at: Safe.dateIso,
  subject: Safe.str,
  body: Safe.str,
  address: Safe.optional(Safe.str),
  town: Safe.optional(Safe.str),
  postcode: Safe.optional(Safe.str),
});

export const thankYouEmailParamsSerializer = Safe.obj({
  campaigns: Safe.optional(CampaignProviderConfigSerializer),
  member_email: Safe.str,
  member_name: Safe.str,
  action_title: Safe.str,
  template: Safe.str,
  thank_you_email_subject: Safe.str,
  thank_you_email_body: Safe.str,
  thank_you_email_footer: Safe.str,
  action_url: Safe.str,
  from_name: Safe.str,
  response_url: Safe.optional(Safe.str),
  sent_message: Safe.optional(sentMessageSerializer),
  share_description: Safe.str,
});
export type ThankYouEmailParams = Safe.TypeIn<typeof thankYouEmailParamsSerializer>;
